import { render, staticRenderFns } from "./PMC.vue?vue&type=template&id=686d11e4&scoped=true"
import script from "./PMC.vue?vue&type=script&lang=js"
export * from "./PMC.vue?vue&type=script&lang=js"
import style0 from "./PMC.vue?vue&type=style&index=0&id=686d11e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d11e4",
  null
  
)

export default component.exports